import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import type { CookieConsent } from "../constants/cookie-consent";
import {
  COOKIE_CONSENT_COOKIE_NAME,
  DEVICE_ID_COOKIE_NAME,
  MARKETING_COOKIES,
} from "../constants/cookies";
import { consentToList } from "./cookie-utils";

export function updateConsent(consentObj: CookieConsent | null) {
  const cookieOptions = {
    sameSite: "lax" as const,
    path: "/",
    domain:
      window.location.hostname === "localhost" ? undefined : ".agreena.com",
    secure: process.env.NODE_ENV === "production",
    expires: 365,
  };

  let deviceId = Cookies.get(DEVICE_ID_COOKIE_NAME) ?? null;

  if (!deviceId && consentObj?.statistics) {
    deviceId = uuidv4();
    Cookies.set(DEVICE_ID_COOKIE_NAME, deviceId, cookieOptions);
  }

  if (!consentObj?.statistics) {
    Cookies.remove(DEVICE_ID_COOKIE_NAME);
  }

  if (!consentObj?.marketing) {
    for (const cookie of MARKETING_COOKIES) Cookies.remove(cookie);
  }

  const prevConsent = Cookies.get(COOKIE_CONSENT_COOKIE_NAME);
  const consent = consentToList(consentObj)?.join(",");

  //
  if (consent && prevConsent !== consent) {
    Cookies.set(COOKIE_CONSENT_COOKIE_NAME, consent, cookieOptions);
  }

  return deviceId;
}
